// extracted by mini-css-extract-plugin
var _1 = "assets-js-common-components-MegaNav-MegaNavVariant-components-GlobalNav-components-Login-components-AccountPreview-UserAvatar-module__userAvatar__H6MUD";
export { _1 as "userAvatar" }
